import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

function tratamentoResponse(response, chamada) {
    if (response.data.codErro > 0) {
        RegistrarLogErro(
            response.data.mensagem,
            chamada ?? "tratamentoResponse",
            response.config?.data
        )
        return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
    } else if (typeof response.data == "string" && response.data !== "") {
        RegistrarLogErro(response.data, chamada ?? "tratamentoResponse", response.config?.data) //, traceId)
        return {
            retornoErro: 1,
            mensagem: chamada + " - Erro inesperado, entre em contato com os reponsáveis.",
        }
    } else return response.data
}

const ErroRequisicao = function (data, aplicativoDados) {
    try {
        if (data.message == "Network Error") {
            return "Verifique sua conexão!"
            // return 'Sem Internet ou sistema fora do ar!'
        } else if (data.message) {
            return "Erro: " + data.message
        }
        return false
    } catch (error) {
        RegistrarLogErro(error, "ErroRequisicao", data)
    }
}

export const AtualizarStatusPedido = async function (data, aplicativoDados) {
    try {
        const response = await api
            .post("cliente/AtualizarStatusPedido", data, {
                headers: { "Content-Type": "application/json" },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "AtualizarStatusPedido")
    } catch (error) {
        RegistrarLogErro(error, "AtualizarStatusPedido", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const CadastrarPedido = async function (data, aplicativoDados) {
    try {
        const response = await api
            .post("cliente/CadastrarPedido", data, {
                // x-api-version >= 1.3 (VersionFuncionalidade.PIX_VERSION no sistemaadm) é
                // obrigatório para o Pix Online (forma 88): sem ele o backend não devolve o
                // pedido para o front — envia o link de pagamento por SMS ao cliente e zera
                // id/status do pedido retornado, com codErro 1.
                headers: { "Content-Type": "application/json", "x-api-version": 1.3 },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "CadastrarPedido")
    } catch (error) {
        RegistrarLogErro(error, "CadastrarPedido", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

/**
 * Cancela o pedido pelo endpoint do cliente (mesmo usado pelo site de pedidos).
 * Usado no Registrador quando o operador desiste do Pix Online antes do pagamento.
 */
export const CancelarPedido = async function (data, aplicativoDados) {
    try {
        const response = await api
            .post("cliente/CancelarPedido", data, {
                headers: { "Content-Type": "application/json" },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        return tratamentoResponse(response, "CancelarPedido")
    } catch (error) {
        RegistrarLogErro(error, "CancelarPedido", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const ObterStatusPedido = async function (idPedido, aplicativoDados) {
    try {
        const response = await api
            .get("cliente/ObterStatusPedido/" + idPedido, {
                headers: { "Content-Type": "application/json", "app-version": 1.0 },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        return tratamentoResponse(response, "ObterStatusPedido")
    } catch (error) {
        RegistrarLogErro(error, "ObterStatusPedido", idPedido)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const ObterStatusPedidoPorUuid = async function (uuid, aplicativoDados) {
    try {
        const response = await api
            .get("cliente/ObterStatusPedidoPorUuid/" + uuid, {
                headers: { "Content-Type": "application/json", "app-version": 1.0 },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        return tratamentoResponse(response, "ObterStatusPedidoPorUuid")
    } catch (error) {
        RegistrarLogErro(error, "ObterStatusPedidoPorUuid", uuid)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const listarEnderecos = async function (Authorization, data, appName) {
    try {
        const response = await api.post("cliente/ObterEnderecosComTaxaEntrega", data, {
            headers: {
                "Content-Type": "application/json",
                Authorization: Authorization,
                app: appName,
            },
        })


        return tratamentoResponse(response, "listarEnderecos")
    } catch (error) {
        RegistrarLogErro(error, "listarEnderecos", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const CadastrarEnderecoCliente = async function (Authorization, data) {
    try {
        const response = await api
            .post("cliente/CadastrarEnderecoCliente", data, {
                headers: { "Content-Type": "application/json", Authorization: Authorization },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "CadastrarEnderecoCliente")
    } catch (error) {
        RegistrarLogErro(error, "CadastrarEnderecoCliente", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const AtualizarEnderecoCliente = async function (Authorization, data) {
    try {
        const response = await api.post("cliente/CadastrarEnderecoCliente", data, {
            headers: { "Content-Type": "application/json", Authorization: Authorization },
        })


        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }
        else return response.data
    } catch (error) {
        RegistrarLogErro(error, "AtualizarEnderecoCliente", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const CadastrarUsuarioBasico = async function (Authorization, data) {
    try {
        const response = await api.post("cliente/CadastrarUsuarioBasico", data, {
            headers: { "Content-Type": "application/json", Authorization: Authorization },
        })


        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }
        else return response.data
    } catch (error) {
        RegistrarLogErro(error, "CadastrarUsuarioBasico", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const CadastrarUsuario = async function (Authorization, data) {
    try {
        const response = await api
            .post("cliente/CadastrarUsuario", data, {
                headers: { "Content-Type": "application/json", Authorization: Authorization },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "CadastrarUsuario")
    } catch (error) {
        RegistrarLogErro(error, "CadastrarUsuario", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const buscarDescontoCliente = async (idCliente, idEstabelecimento, authorization) => {
    try {
        const url = `/cliente/descontos?idCliente=${idCliente}&idEstabelecimento=${idEstabelecimento}`
        const headers = { "Content-Type": "application/json", Authorization: authorization }

        const response = await api.get(url, { headers })

        console.warn("buscarDescontoCliente =>", response)

        return tratamentoResponse(response, "obterCardapioRegistrador")
    } catch (error) {
        RegistrarLogErro(error, "buscarDescontoCliente")
        return { retornoErro: 1, mensagem: error.message }
    }
}
